import CollapsibleContentIntro from './CollapsibleContentIntro';

export default CollapsibleContentIntro;
